/**
 * Unique id of the action used in telemetry, mapped to the OfficeActionId
 */
export var OfficeActionTelemetryId;
(function (OfficeActionTelemetryId) {
    OfficeActionTelemetryId["ConvertToPdf"] = "convertToPdf";
    OfficeActionTelemetryId["ViewPdfExternal"] = "viewPdfExternal";
    OfficeActionTelemetryId["CopyLink"] = "copyLink";
    OfficeActionTelemetryId["CreateTodo"] = "createTodo";
    OfficeActionTelemetryId["ViewTodoExternal"] = "viewTodoExternal";
    OfficeActionTelemetryId["Download"] = "download";
    OfficeActionTelemetryId["LocalCopyLink"] = "localCopyLink";
    OfficeActionTelemetryId["OpenInNative"] = "openInNative";
    OfficeActionTelemetryId["OpenInBrowser"] = "openInBrowser";
    OfficeActionTelemetryId["OpenFileLocation"] = "openFileLocation";
    OfficeActionTelemetryId["Schedule"] = "schedule";
    OfficeActionTelemetryId["Share"] = "share";
    OfficeActionTelemetryId["ShareToTeams"] = "shareToTeams";
})(OfficeActionTelemetryId || (OfficeActionTelemetryId = {}));
//# sourceMappingURL=actionTelemetry.js.map